/**
 * Every `/recurring` route, in one place. `App.tsx` routes them, the screens
 * link and navigate to them, and the tests mount them — all from these
 * constants, so no copy of a path can drift from the others.
 *
 * The literal second segments (`calendar`, `new`, `all`, `suggestions`)
 * outrank `RECURRING_DETAIL_PATH`'s `:id` in react-router's ranking whatever
 * the declaration order, so none of them is ever read as a bill id — provided
 * each is declared as its own `<Route>` (Ruling 41).
 */
export const RECURRING_PATH = '/recurring'
/**
 * The old calendar view's path, kept only for its redirect to `RECURRING_PATH`
 * (#704: the grid now sits on the month screen itself). Still declared as its
 * own `<Route>`, so the literal keeps outranking `:id` (Ruling 41).
 */
export const RECURRING_CALENDAR_PATH = '/recurring/calendar'
export const RECURRING_NEW_PATH = '/recurring/new'
export const RECURRING_ALL_PATH = '/recurring/all'
export const RECURRING_SUGGESTIONS_PATH = '/recurring/suggestions'
export const RECURRING_DETAIL_PATH = '/recurring/:id'

/** One bill's detail. The id is encoded, so it can only ever fill the `:id` segment. */
export function recurringDetailPath(id: string): string {
  return `${RECURRING_PATH}/${encodeURIComponent(id)}`
}

/**
 * One bill's edit form (P4). Two segments after `/recurring`, so it never
 * competes with `RECURRING_DETAIL_PATH`'s single `:id`.
 */
export const RECURRING_EDIT_PATH = '/recurring/:id/edit'

/** The edit form for one bill. Encoded like `recurringDetailPath`. */
export function recurringEditPath(id: string): string {
  return `${recurringDetailPath(id)}/edit`
}
